import StartIcon from 'components/ReusableComponents/Icons/Start'
import moment from 'moment'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from '../MontlyRevenue.module.scss'
import SingleChart from '../SingleChart.js'
import { dataTypesToShow } from '../utils/constants'
import { barColors } from '../utils/constants'
import { currencyFormatter } from '../utils/formatters'

const Charts = ({
  data,
  firstYear,
  secondYear,
  name,
  syncId,
  dataToShow,
  isDemoMode
}) => {
  return (
    <div className={styles.chartsHolder}>
      <div className={styles.chartsHeader}>
        {name && (
          <p className={styles.groupBreakdownTitle}>
            {isDemoMode ? `Directful Demo Hotel` : name}
          </p>
        )}
        {data.serviceStartDate && (
          <p className={styles.serviceStartDate}>
            <StartIcon />
            {moment(data.serviceStartDate).format('MMMM D, YYYY')}
          </p>
        )}
      </div>

      <SingleChart
        label="revenue"
        data={data.monthlyRevenues}
        firstYear={firstYear}
        secondYear={secondYear}
        syncId={syncId}
        firstYearColor={barColors.revenue.firstYear}
        secondYearColor={barColors.revenue.secondYear}
        deltaPercentage={data.revenueDeltaPercentage}
        deltaFlat={data.revenueDeltaFlat}
        firstYearTotal={currencyFormatter.format(data.firstYearRevenue)}
        secondYearTotal={currencyFormatter.format(data.secondYearRevenue)}
        serviceStartDate={data.serviceStartDate}
        valueFormatter={value => currencyFormatter.format(value)}
        isHighDeltaGood={[dataTypesToShow.Direct, dataTypesToShow.Consumed].includes(
          dataToShow
        )}
      />
      <SingleChart
        label="bookings"
        data={data.monthlyBookings}
        firstYear={firstYear}
        secondYear={secondYear}
        syncId={syncId}
        firstYearColor={barColors.bookings.firstYear}
        secondYearColor={barColors.bookings.secondYear}
        deltaPercentage={data.bookingsDeltaPercentage}
        deltaFlat={data.bookingsDeltaFlat}
        firstYearTotal={formatNumberAsThousands(data.firstYearBookings)}
        secondYearTotal={formatNumberAsThousands(data.secondYearBookings)}
        serviceStartDate={data.serviceStartDate}
        isHighDeltaGood={[dataTypesToShow.Direct, dataTypesToShow.Consumed].includes(
          dataToShow
        )}
      />
      <SingleChart
        label="messages"
        data={data.monthlyMessages}
        firstYear={firstYear}
        secondYear={secondYear}
        syncId={syncId}
        firstYearColor={barColors.messages.firstYear}
        secondYearColor={barColors.messages.secondYear}
        deltaPercentage={data.messagesDeltaPercentage}
        deltaFlat={data.messagesDeltaFlat}
        firstYearTotal={formatNumberAsThousands(data.firstYearMessages)}
        secondYearTotal={formatNumberAsThousands(data.secondYearMessages)}
        serviceStartDate={data.serviceStartDate}
        isHighDeltaGood={[dataTypesToShow.Direct, dataTypesToShow.Consumed].includes(
          dataToShow
        )}
      />
    </div>
  )
}

export default Charts
